var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Homeicon"),
      _vm._v(" "),
      _c("UserName"),
      _vm._v(" "),
      _vm.$route.name !== "Home" ? _c("Backicon") : _vm._e(),
      _vm._v(" "),
      _c("img", {
        staticClass: "tutorial_button",
        attrs: { src: require("@/assets/img/how_to_play.png") },
        on: { click: _vm.showModal }
      }),
      _vm._v(" "),
      _c("Modal", {
        attrs: { is_active: _vm.is_active },
        on: {
          test: function($event) {
            _vm.is_active = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61dd7a3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dd7a3d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 